const features = [
  {
    icon: 'ri-4k-line',
    title: '1080P/4K 超清画质',
    desc: '全线资源默认高清画质，热门影片支持4K超清，给您影院级的观影享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '智能加速不缓冲',
    desc: '全球CDN节点部署，智能自适应码率，无论网络环境如何都能流畅播放不卡顿。',
  },
  {
    icon: 'ri-device-line',
    title: '全终端无缝切换',
    desc: '手机、平板、电脑三端数据同步，随时随地接续观看，不错过任何精彩瞬间。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '纯净无广告体验',
    desc: 'APP端纯净观影模式，无弹窗、无强制广告，让您沉浸在影片世界不受打扰。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            平台优势
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            为什么超过千万用户选择蚂蚁影视
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-100 border border-background-300/30 rounded-xl p-6 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-400`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-100 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}